import type {BagStore} from "./BagStore";
import type ProfileStore from "./ProfileStore";
import type {MithraMaterializedApi} from "../services/MithraMaterializedApi";
import {makeAutoObservable} from "mobx";
import {CommonSuppliersDelegate} from "./synergy/CommonSuppliersDelegate";
import {CommonCategoriesDelegate} from "./synergy/CommonCategoriesDelegate";

export class SynergyStore {
    requestedSynergyId?: number;
    openRowSpId: string = '';

    /**
     * The list of source databag IDs for the synergy.
     * If this is null, it means it's still loading
     */
    srcDatabagIds: number[] | null = null;

    readonly datasetNameLeft: string;
    readonly datasetNameRight: string;
    readonly commonSuppliersDelegate: CommonSuppliersDelegate;
    readonly commonCategoriesDelegate: CommonCategoriesDelegate;

    constructor(
        private matApi: MithraMaterializedApi,
        private bagStore: BagStore,
        private profileStore: ProfileStore,
    ) {
        this.requestedSynergyId = this.profileStore.p.hardcodedSynergyId || 1;
        this.datasetNameLeft = this.profileStore.p.hardcodedDatasetNameLeft || 'None'
        this.datasetNameRight = this.profileStore.p.hardcodedDatasetNameRight || 'None'
        this.commonSuppliersDelegate = new CommonSuppliersDelegate(this, this.bagStore, this.matApi, this.profileStore)
        this.commonCategoriesDelegate = new CommonCategoriesDelegate(this, this.bagStore, this.matApi, this.profileStore)

        makeAutoObservable(this);
    }

    get isSynergyDatabag(): boolean {
        return this.srcDatabagIds !== null && (this.srcDatabagIds.length > 0) && (this.srcDatabagIds.length <= 4);
    }

    getSynergySrcs(databag: number) {
        this.setSynergySrcs(null)
        this.matApi.getSrcDatabagIds(databag)
            .then(resp => this.setSynergySrcs(resp.data))
            .catch(() => this.setSynergySrcs([]));
    }

    setSynergySrcs(srcDatabagIds: number[] | null) {
        this.srcDatabagIds = srcDatabagIds;
    }
}
